import script from "./labhomeItems.vue?vue&type=script&setup=true&lang=js"
export * from "./labhomeItems.vue?vue&type=script&setup=true&lang=js"

import "./labhomeItems.vue?vue&type=style&index=0&id=78192a0e&lang=less&scoped=true"

import exportComponent from "D:\\openAi\\chinese-academy-of-sciences-home\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-78192a0e"]])

export default __exports__